import {useState, useCallback} from 'react';


const useDateRange = (interval, dashboardDate={}) => {
    const ds = new Date();
    const de = new Date();
    ds.setMonth(de.getMonth() - interval);
    const [startDate, setStartDate] = useState(dashboardDate.startDate || ds);
    const [endDate, setEndDate] = useState(dashboardDate.endDate || de);

    const setStartDateCall = useCallback((date) => {
        date && setStartDate(date);
    }, []);

    const setEndDateCall = useCallback((date) => {
        date && setEndDate(date);
    }, []);

    return {startDate, setStartDateCall, endDate, setEndDateCall};
};

export default useDateRange;
